/* Pawsy custom order tracker — talks to our serverless proxy (which calls the
 * ParcelPanel API server-side) and renders fully brand-styled results.
 * No third-party widget. Progressive enhancement: needs JS + the API URL. */
(function () {
  'use strict';

  var STEPS = ['Ordered', 'Info received', 'In transit', 'Out for delivery', 'Delivered'];
  var STATUS_INDEX = {
    PENDING: 0,
    INFO_RECEIVED: 1,
    IN_TRANSIT: 2,
    EXCEPTION: 2,
    FAILED_ATTEMPT: 2,
    EXPIRED: 2,
    OUT_FOR_DELIVERY: 3,
    READY_FOR_PICKUP: 3,
    DELIVERED: 4,
  };

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function fmtDate(iso) {
    if (!iso) return '';
    var d = new Date(iso);
    if (isNaN(d.getTime())) return esc(iso);
    try {
      return d.toLocaleString(undefined, {
        month: 'short', day: 'numeric', year: 'numeric', hour: 'numeric', minute: '2-digit',
      });
    } catch (e) {
      return d.toDateString();
    }
  }

  function stepsHtml(idx, delivered) {
    var html = '<div class="pl-ot-steps">';
    for (var i = 0; i < STEPS.length; i++) {
      var cls = 'pl-ot-step';
      if (delivered || i < idx) cls += ' is-done';
      else if (i === idx) cls += ' is-current';
      html += '<div class="' + cls + '"><span>' + esc(STEPS[i]) + '</span></div>';
    }
    return html + '</div>';
  }

  function shipmentHtml(s) {
    var idx = STATUS_INDEX[s.status];
    if (idx == null) idx = 1;
    var delivered = s.status === 'DELIVERED';
    var label = s.status_label || STEPS[idx] || 'In progress';

    var html = '';
    html += '<div class="pl-ot-head"><h3>Your order</h3><span class="pl-ot-pill">' + esc(label) + '</span></div>';

    if (s.estimated_delivery) {
      html += '<p class="pl-ot-eta">Estimated delivery: <b>' + esc(s.estimated_delivery) + '</b></p>';
    } else if (delivered && s.delivery_date) {
      html += '<p class="pl-ot-eta">Delivered <b>' + fmtDate(s.delivery_date) + '</b></p>';
    }

    html += stepsHtml(idx, delivered);

    // timeline
    if (s.checkpoints && s.checkpoints.length) {
      html += '<p class="pl-ot-section-title">Tracking history</p><ul class="pl-ot-timeline">';
      for (var i = 0; i < s.checkpoints.length; i++) {
        var c = s.checkpoints[i];
        html += '<li class="pl-ot-tl-item"><b>' + esc(c.detail || c.status_label || '') + '</b>' +
          (c.time ? '<time>' + fmtDate(c.time) + '</time>' : '') + '</li>';
      }
      html += '</ul>';
    }

    // products
    if (s.products && s.products.length) {
      html += '<p class="pl-ot-section-title">In this shipment</p><div class="pl-ot-products">';
      for (var p = 0; p < s.products.length; p++) {
        var pr = s.products[p];
        var inner =
          (pr.image_url ? '<img src="' + esc(pr.image_url) + '" alt="" loading="lazy">' : '') +
          '<span><span class="pl-ot-pname">' + esc(pr.title) + '</span>' +
          '<span class="pl-ot-pqty">' + (pr.variant_title ? esc(pr.variant_title) + ' · ' : '') + 'Qty ' + esc(pr.quantity) + '</span></span>';
        html += pr.url
          ? '<a class="pl-ot-product" href="' + esc(pr.url) + '" target="_blank" rel="noopener">' + inner + '</a>'
          : '<div class="pl-ot-product">' + inner + '</div>';
      }
      html += '</div>';
    }

    // meta — plain text only, NO external carrier links (keep customers on-site)
    var meta = [];
    if (s.tracking_number) meta.push('Tracking #: <b>' + esc(s.tracking_number) + '</b>');
    if (meta.length) html += '<div class="pl-ot-meta">' + meta.join('<br>') + '</div>';

    return html;
  }

  function render(result, data) {
    var html = '';
    var ships = data.shipments || [];
    if (!ships.length) {
      // confirmed but not yet fulfilled
      html += '<div class="pl-ot-head"><h3>Order ' + esc(data.order_number) + '</h3><span class="pl-ot-pill">Confirmed</span></div>';
      html += '<p class="pl-ot-eta">Your order is confirmed. Tracking details will appear here as soon as it ships — you’ll also get an email.</p>';
      html += stepsHtml(0, false);
    } else {
      for (var i = 0; i < ships.length; i++) {
        if (i > 0) html += '<hr style="border:0;border-top:1px solid var(--pl-border);margin:28px 0;">';
        html += shipmentHtml(ships[i]);
      }
      // prepend order number into the first head
      html = html.replace('>Your order<', '>Order ' + esc(data.order_number) + '<');
    }
    result.innerHTML = html;
    result.hidden = false;
  }

  function initOne(root) {
    var api = (root.getAttribute('data-tracker-api') || '').trim();
    var form = root.querySelector('.pl-ot-form');
    var note = root.querySelector('.pl-ot-note');
    var result = root.querySelector('.pl-ot-result');
    var btn = root.querySelector('.pl-ot-submit');
    var label = root.querySelector('.pl-ot-submit-label');
    if (!form) return;

    function showNote(msg, ok) {
      note.textContent = msg;
      note.className = 'pl-ot-note' + (ok ? ' is-ok' : '');
      note.hidden = false;
    }

    var extras = root.querySelector('.pl-ot-extras');

    function runLookup(order, email) {
      note.hidden = true;
      result.hidden = true;
      result.innerHTML = '';
      if (extras) extras.hidden = true;

      order = (order || '').trim();
      email = (email || '').trim();
      if (!order || !email) { showNote('Please enter your order number and email.'); return; }
      if (!api) { showNote('Tracker isn’t configured yet. Please email help@pawsylabs.com.'); return; }

      var original = label ? label.textContent : '';
      if (btn) btn.disabled = true;
      if (label) label.textContent = 'Tracking…';

      var url = api + (api.indexOf('?') === -1 ? '?' : '&') +
        'order=' + encodeURIComponent(order) + '&email=' + encodeURIComponent(email);

      fetch(url, { method: 'GET', headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, body: j }; }); })
        .then(function (res) {
          if (!res.ok) {
            showNote((res.body && res.body.error) || 'Sorry, we couldn’t track that order.');
            return;
          }
          render(result, res.body);
          if (extras) {
            var ships = (res.body && res.body.shipments) || [];
            var delivered = ships.length > 0 && ships.every(function (s) { return s.status === 'DELIVERED'; });
            extras.hidden = delivered; // hide "while you wait" once everything's delivered
          }
        })
        .catch(function () {
          showNote('Something went wrong reaching the tracker. Please try again, or email help@pawsylabs.com.');
        })
        .then(function () {
          if (btn) btn.disabled = false;
          if (label) label.textContent = original;
        });
    }

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      runLookup(form.order && form.order.value, form.email && form.email.value);
    });

    // Deep link auto-track (ParcelPanel email-link format):
    //   ?order=PL123&token=<email reversed, "@" -> "_-_">  (also accepts ?email= and ?nums=)
    try {
      var qs = new URLSearchParams(window.location.search);
      var dOrder = (qs.get('order') || qs.get('nums') || '').trim();
      var dEmail = (qs.get('email') || '').trim();
      var token = qs.get('token');
      if (!dEmail && token) {
        dEmail = token.replace(/_-_/g, '@').split('').reverse().join('');
      }
      if (dOrder && dEmail) {
        if (form.order) form.order.value = dOrder;
        if (form.email) form.email.value = dEmail;
        runLookup(dOrder, dEmail);
        try { root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } catch (e2) {}
      }
    } catch (e1) {}
  }

  function init() {
    var roots = document.querySelectorAll('.pl-ot');
    for (var i = 0; i < roots.length; i++) initOne(roots[i]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
